import React, { useState } from "react";
import styles from "./Menu.module.css";
import image from "../../asset/images/Avatar.png";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/redux-store/Index";
import Modal from "../UI/Modal";
import { dongleActions } from "../../store/redux-store/dongle-store";

function Menu(props) {
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  let personalData = useSelector((data) => data.auth.loginData);

  // All dispatches to take place after user logsout
  const logoutDispatchActions = () => {
    dispatch(authActions.logOut());
    dispatch(authActions.resetToDefault());
    dispatch(authActions.resetToDefault2());
    dispatch(authActions.resetLiveMetrics());
    dispatch(dongleActions.clearDonglesInfo());
    dispatch(authActions.loggedOut());
  };

  //Log a user out of the application
  const backHandler = () => {
    setModal(false);
    props.setShowMenu(false);
    logoutDispatchActions();
    navigate("/login");
  };
  const proceedHandlerFinal = () => {
    setModal(false);
  };

  return (
    <div>
      {" "}
      {modal && (
        <Modal
          title="Logout?"
          message="You are about to logout."
          messageExtra="Are you sure you want to logout?"
          back="No"
          accept="Yes"
          close={proceedHandlerFinal}
          confirm={backHandler}
        />
      )}{" "}
      <div className={styles.menu__modal}>
        <div className={styles.menu__modal__inner}>
          <div className={styles.modal__header}>
            <div className={styles.wrapper}>
              <img src={image} alt="profile" />
            </div>
            <div>
              <h4>{personalData[0].fullname}</h4>
              <p>{personalData[0].email}</p>
            </div>
          </div>
          <div className={styles.menu__modal__list}>
            {/* <div className={styles.nav_container}>
              <NavLink
                to="/account"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 6C11.2583 6 10.5333 6.21993 9.91661 6.63199C9.29993 7.04404 8.81928 7.62971 8.53545 8.31494C8.25162 9.00016 8.17736 9.75416 8.32205 10.4816C8.46675 11.209 8.8239 11.8772 9.34835 12.4017C9.8728 12.9261 10.541 13.2833 11.2684 13.4279C11.9958 13.5726 12.7498 13.4984 13.4351 13.2145C14.1203 12.9307 14.706 12.4501 15.118 11.8334C15.5301 11.2167 15.75 10.4917 15.75 9.75C15.75 8.75544 15.3549 7.80161 14.6517 7.09835C13.9484 6.39509 12.9946 6 12 6ZM12 12C11.555 12 11.12 11.868 10.75 11.6208C10.38 11.3736 10.0916 11.0222 9.92127 10.611C9.75097 10.1999 9.70642 9.7475 9.79323 9.31105C9.88005 8.87459 10.0943 8.47368 10.409 8.15901C10.7237 7.84434 11.1246 7.63005 11.561 7.54323C11.9975 7.45642 12.4499 7.50097 12.861 7.67127C13.2722 7.84157 13.6236 8.12996 13.8708 8.49997C14.118 8.86998 14.25 9.30499 14.25 9.75C14.2494 10.3466 14.0122 10.9185 13.5903 11.3403C13.1685 11.7622 12.5966 11.9994 12 12Z"
                        fill="#03C962"
                      />
                      <path
                        d="M12 1.5C9.9233 1.5 7.89323 2.11581 6.16651 3.26957C4.4398 4.42332 3.09398 6.0632 2.29926 7.98182C1.50454 9.90045 1.29661 12.0116 1.70175 14.0484C2.1069 16.0852 3.10693 17.9562 4.57538 19.4246C6.04383 20.8931 7.91475 21.8931 9.95155 22.2982C11.9884 22.7034 14.0996 22.4955 16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335C21.8842 16.1068 22.5 14.0767 22.5 12C22.4968 9.2162 21.3896 6.54733 19.4211 4.57889C17.4527 2.61044 14.7838 1.50318 12 1.5ZM7.5 19.7828V18.75C7.5006 18.1534 7.73784 17.5815 8.15967 17.1597C8.5815 16.7378 9.15345 16.5006 9.75 16.5H14.25C14.8466 16.5006 15.4185 16.7378 15.8403 17.1597C16.2622 17.5815 16.4994 18.1534 16.5 18.75V19.7828C15.1344 20.5802 13.5814 21.0004 12 21.0004C10.4186 21.0004 8.86562 20.5802 7.5 19.7828ZM17.994 18.6945C17.9791 17.7107 17.5782 16.7722 16.8779 16.0812C16.1776 15.3901 15.2339 15.0019 14.25 15H9.75C8.76614 15.0019 7.82238 15.3901 7.12207 16.0812C6.42175 16.7722 6.02095 17.7107 6.006 18.6945C4.64592 17.4801 3.6868 15.8812 3.25563 14.1095C2.82445 12.3378 2.94157 10.477 3.59148 8.77339C4.24138 7.06978 5.39341 5.60375 6.89503 4.56942C8.39664 3.5351 10.177 2.98127 12.0004 2.98127C13.8237 2.98127 15.6041 3.5351 17.1057 4.56942C18.6073 5.60375 19.7594 7.06978 20.4093 8.77339C21.0592 10.477 21.1763 12.3378 20.7451 14.1095C20.314 15.8812 19.3548 17.4801 17.9948 18.6945H17.994Z"
                        fill="#03C962"
                      />
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>My Account</p>
                  </div>
                </div>
              </NavLink>
            </div> */}

            <div className={styles.nav_container}>
              <NavLink
                to="/orders"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_11_192717)">
                        <path
                          d="M10 5.33331H16V6.66665H10V5.33331Z"
                          fill="#03C962"
                        />
                        <path d="M10 8H16V9.33333H10V8Z" fill="#03C962" />
                        <path
                          d="M10 10.6666H16V12H10V10.6666Z"
                          fill="#03C962"
                        />
                        <path
                          d="M10 13.3334H16V14.6667H10V13.3334Z"
                          fill="#03C962"
                        />
                        <path d="M10 16H16V17.3333H10V16Z" fill="#03C962" />
                        <path
                          d="M7.33203 5.33331H8.66536V6.66665H7.33203V5.33331Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33203 8H8.66536V9.33333H7.33203V8Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33203 10.6666H8.66536V12H7.33203V10.6666Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33203 13.3334H8.66536V14.6667H7.33203V13.3334Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33203 16H8.66536V17.3333H7.33203V16Z"
                          fill="#03C962"
                        />
                        <path
                          d="M18.6667 1.33331H5.33333C4.97971 1.33331 4.64057 1.47379 4.39052 1.72384C4.14048 1.97389 4 2.31302 4 2.66665V21.3333C4 21.6869 4.14048 22.0261 4.39052 22.2761C4.64057 22.5262 4.97971 22.6666 5.33333 22.6666H18.6667C19.0203 22.6666 19.3594 22.5262 19.6095 22.2761C19.8595 22.0261 20 21.6869 20 21.3333V2.66665C20 2.31302 19.8595 1.97389 19.6095 1.72384C19.3594 1.47379 19.0203 1.33331 18.6667 1.33331ZM18.6667 21.3333H5.33333V2.66665H18.6667V21.3333Z"
                          fill="#03C962"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_11_192717">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>My orders</p>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className={styles.nav_container}>
              <NavLink
                to="/history"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2H12.25C12.4667 2 12.646 2.07067 12.788 2.212C12.9293 2.354 13 2.53333 13 2.75V10.275C13.3 10.4583 13.5417 10.6957 13.725 10.987C13.9083 11.279 14 11.6167 14 12C14 12.55 13.8043 13.0207 13.413 13.412C13.021 13.804 12.55 14 12 14C11.45 14 10.9793 13.804 10.588 13.412C10.196 13.0207 10 12.55 10 12C10 11.6167 10.0917 11.275 10.275 10.975C10.4583 10.675 10.7 10.4417 11 10.275V8.125C10.1333 8.35833 9.41667 8.829 8.85 9.537C8.28333 10.2457 8 11.0667 8 12C8 13.1 8.39167 14.0417 9.175 14.825C9.95833 15.6083 10.9 16 12 16C13.1 16 14.0417 15.6083 14.825 14.825C15.6083 14.0417 16 13.1 16 12C16 11.6167 15.946 11.2373 15.838 10.862C15.7293 10.4873 15.5667 10.1333 15.35 9.8C15.2 9.56667 15.1377 9.33733 15.163 9.112C15.1877 8.88733 15.2833 8.69167 15.45 8.525C15.65 8.325 15.904 8.225 16.212 8.225C16.5207 8.225 16.7667 8.35833 16.95 8.625C17.3167 9.15833 17.5833 9.71233 17.75 10.287C17.9167 10.8623 18 11.4333 18 12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18C10.3333 18 8.91667 17.4167 7.75 16.25C6.58333 15.0833 6 13.6667 6 12C6 10.5 6.475 9.196 7.425 8.088C8.375 6.97933 9.56667 6.30833 11 6.075V4.05C9.01667 4.3 7.35433 5.175 6.013 6.675C4.671 8.175 4 9.95 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 11.0167 19.8583 10.1333 19.575 9.35C19.2917 8.56667 18.8917 7.84167 18.375 7.175C18.1917 6.94167 18.1043 6.69167 18.113 6.425C18.121 6.15833 18.225 5.925 18.425 5.725C18.625 5.525 18.8627 5.425 19.138 5.425C19.4127 5.425 19.6333 5.53333 19.8 5.75C20.5 6.6 21.0417 7.54167 21.425 8.575C21.8083 9.60833 22 10.75 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
                        fill="#03C962"
                      />
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>History</p>
                  </div>
                </div>
              </NavLink>
            </div>

            {/* <NavLink
              to="/"
              // className={(navData) =>
              //   navData.isActive ? `${styles.active}` : ""
              // }
            >
              <div>
                <div className={styles.svg}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4879_45999)">
                      <path
                        d="M10 5.33398H16V6.66732H10V5.33398Z"
                        fill="#03C962"
                      />
                      <path d="M10 8H16V9.33333H10V8Z" fill="#03C962" />
                      <path
                        d="M10 10.666H16V11.9993H10V10.666Z"
                        fill="#03C962"
                      />
                      <path
                        d="M10 13.334H16V14.6673H10V13.334Z"
                        fill="#03C962"
                      />
                      <path d="M10 16H16V17.3333H10V16Z" fill="#03C962" />
                      <path
                        d="M7.33337 5.33398H8.66671V6.66732H7.33337V5.33398Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33337 8H8.66671V9.33333H7.33337V8Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33337 10.666H8.66671V11.9993H7.33337V10.666Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33337 13.334H8.66671V14.6673H7.33337V13.334Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33337 16H8.66671V17.3333H7.33337V16Z"
                        fill="#03C962"
                      />
                      <path
                        d="M18.6667 1.33398H5.33333C4.97971 1.33398 4.64057 1.47446 4.39052 1.72451C4.14048 1.97456 4 2.3137 4 2.66732V21.334C4 21.6876 4.14048 22.0267 4.39052 22.2768C4.64057 22.5268 4.97971 22.6673 5.33333 22.6673H18.6667C19.0203 22.6673 19.3594 22.5268 19.6095 22.2768C19.8595 22.0267 20 21.6876 20 21.334V2.66732C20 2.3137 19.8595 1.97456 19.6095 1.72451C19.3594 1.47446 19.0203 1.33398 18.6667 1.33398ZM18.6667 21.334H5.33333V2.66732H18.6667V21.334Z"
                        fill="#03C962"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4879_45999">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className={styles.title}>
                  <p>Spare parts (Coming soon)</p>
                </div>
              </div>
            </NavLink> */}

            {/* <div className={styles.nav_container}>
              <NavLink>
                <div className={styles.svg}>
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1090_6026)">
                      <path
                        d="M10 5.33301H16V6.66634H10V5.33301Z"
                        fill="#03C962"
                      />
                      <path d="M10 8H16V9.33333H10V8Z" fill="#03C962" />
                      <path
                        d="M10 10.667H16V12.0003H10V10.667Z"
                        fill="#03C962"
                      />
                      <path
                        d="M10 13.333H16V14.6663H10V13.333Z"
                        fill="#03C962"
                      />
                      <path d="M10 16H16V17.3333H10V16Z" fill="#03C962" />
                      <path
                        d="M7.33333 5.33301H8.66667V6.66634H7.33333V5.33301Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33333 8H8.66667V9.33333H7.33333V8Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33333 10.667H8.66667V12.0003H7.33333V10.667Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33333 13.333H8.66667V14.6663H7.33333V13.333Z"
                        fill="#03C962"
                      />
                      <path
                        d="M7.33333 16H8.66667V17.3333H7.33333V16Z"
                        fill="#03C962"
                      />
                      <path
                        d="M18.6667 1.33301H5.33333C4.97971 1.33301 4.64057 1.47348 4.39052 1.72353C4.14048 1.97358 4 2.31272 4 2.66634V21.333C4 21.6866 4.14048 22.0258 4.39052 22.2758C4.64057 22.5259 4.97971 22.6663 5.33333 22.6663H18.6667C19.0203 22.6663 19.3594 22.5259 19.6095 22.2758C19.8595 22.0258 20 21.6866 20 21.333V2.66634C20 2.31272 19.8595 1.97358 19.6095 1.72353C19.3594 1.47348 19.0203 1.33301 18.6667 1.33301ZM18.6667 21.333H5.33333V2.66634H18.6667V21.333Z"
                        fill="#03C962"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1090_6026">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className={styles.title}>
                  <p>My orders</p>
                </div>
              </NavLink>
            </div> */}

            {/* <div className={styles.nav_container}>
              <NavLink
                to="/insurance-home"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.5 12V11.8966L18.459 11.8017L16.306 6.81781C16.0316 6.04837 15.2884 5.5 14.42 5.5H9.42C8.54901 5.5 7.80399 6.05165 7.5316 6.82472L5.53576 11.8143L5.5 11.9037V12V16C5.5 16.8261 6.17386 17.5 7 17.5H8C8.82614 17.5 9.5 16.8261 9.5 16V15.5H14.5V16C14.5 16.8261 15.1739 17.5 16 17.5H17C17.8261 17.5 18.5 16.8261 18.5 16V12ZM9.75673 8H14.0971L15.2257 10.5H8.74244L9.75673 8ZM8.5 13C8.5 12.7261 8.72614 12.5 9 12.5C9.27386 12.5 9.5 12.7261 9.5 13C9.5 13.2739 9.27386 13.5 9 13.5C8.72614 13.5 8.5 13.2739 8.5 13ZM14.5 13C14.5 12.7261 14.7261 12.5 15 12.5C15.2739 12.5 15.5 12.7261 15.5 13C15.5 13.2739 15.2739 13.5 15 13.5C14.7261 13.5 14.5 13.2739 14.5 13ZM12 1.54716L20.5 5.32494V11C20.5 16.2973 16.8574 21.2335 12 22.4845C7.14262 21.2335 3.5 16.2973 3.5 11V5.32494L12 1.54716Z"
                        stroke="#03C962"
                      />
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>Insurance</p>
                  </div>
                </div>
              </NavLink>
            </div> */}

            <div className={styles.nav_container}>
              <NavLink
                to="/papers"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1090_6026)">
                        <path
                          d="M10 5.33301H16V6.66634H10V5.33301Z"
                          fill="#03C962"
                        />
                        <path d="M10 8H16V9.33333H10V8Z" fill="#03C962" />
                        <path
                          d="M10 10.667H16V12.0003H10V10.667Z"
                          fill="#03C962"
                        />
                        <path
                          d="M10 13.333H16V14.6663H10V13.333Z"
                          fill="#03C962"
                        />
                        <path d="M10 16H16V17.3333H10V16Z" fill="#03C962" />
                        <path
                          d="M7.33333 5.33301H8.66667V6.66634H7.33333V5.33301Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33333 8H8.66667V9.33333H7.33333V8Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33333 10.667H8.66667V12.0003H7.33333V10.667Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33333 13.333H8.66667V14.6663H7.33333V13.333Z"
                          fill="#03C962"
                        />
                        <path
                          d="M7.33333 16H8.66667V17.3333H7.33333V16Z"
                          fill="#03C962"
                        />
                        <path
                          d="M18.6667 1.33301H5.33333C4.97971 1.33301 4.64057 1.47348 4.39052 1.72353C4.14048 1.97358 4 2.31272 4 2.66634V21.333C4 21.6866 4.14048 22.0258 4.39052 22.2758C4.64057 22.5259 4.97971 22.6663 5.33333 22.6663H18.6667C19.0203 22.6663 19.3594 22.5259 19.6095 22.2758C19.8595 22.0258 20 21.6866 20 21.333V2.66634C20 2.31272 19.8595 1.97358 19.6095 1.72353C19.3594 1.47348 19.0203 1.33301 18.6667 1.33301ZM18.6667 21.333H5.33333V2.66634H18.6667V21.333Z"
                          fill="#03C962"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1090_6026">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>Vehicle Papers</p>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className={styles.nav_container}>
              <NavLink
                to="/motorAi"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_2413)">
                        <path
                          d="M6.382 3.96801C7.97574 2.69108 9.9578 1.99676 12 2.00001C14.125 2.00001 16.078 2.73601 17.618 3.96801L19.071 2.51501L20.485 3.92901L19.032 5.38201C20.3089 6.97575 21.0033 8.95782 21 11V12H3V11C3 8.87501 3.736 6.92201 4.968 5.38201L3.515 3.93001L4.929 2.51601L6.382 3.96901V3.96801ZM3 14H21V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8947 20.2652 22 20 22H4C3.73478 22 3.48043 21.8947 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V14ZM9 9.00001C9.26522 9.00001 9.51957 8.89465 9.70711 8.70712C9.89464 8.51958 10 8.26523 10 8.00001C10 7.7348 9.89464 7.48044 9.70711 7.2929C9.51957 7.10537 9.26522 7.00001 9 7.00001C8.73478 7.00001 8.48043 7.10537 8.29289 7.2929C8.10536 7.48044 8 7.7348 8 8.00001C8 8.26523 8.10536 8.51958 8.29289 8.70712C8.48043 8.89465 8.73478 9.00001 9 9.00001ZM15 9.00001C15.2652 9.00001 15.5196 8.89465 15.7071 8.70712C15.8946 8.51958 16 8.26523 16 8.00001C16 7.7348 15.8946 7.48044 15.7071 7.2929C15.5196 7.10537 15.2652 7.00001 15 7.00001C14.7348 7.00001 14.4804 7.10537 14.2929 7.2929C14.1054 7.48044 14 7.7348 14 8.00001C14 8.26523 14.1054 8.51958 14.2929 8.70712C14.4804 8.89465 14.7348 9.00001 15 9.00001Z"
                          fill="#03C962"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_2413">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>Chat with MotorAi</p>
                  </div>
                </div>
              </NavLink>
            </div>

            {/* <div className={styles.nav_container}>
              <NavLink
                to="/services"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.773 3.48534L13.993 3.30134L11.885 5.39734L10.691 4.18134L12.747 2.02434L12.567 1.23234C12.1326 1.08699 11.6781 1.01007 11.22 1.00434C10.7203 0.996652 10.2243 1.09196 9.76303 1.28434C9.31763 1.48595 8.91503 1.7711 8.57703 2.12434C8.20078 2.48075 7.9028 2.91154 7.70203 3.38934C7.31548 4.34022 7.31548 5.40445 7.70203 6.35534C5.61727 8.40633 3.55942 10.4845 1.52903 12.5893C1.31903 12.8643 1.21903 13.2073 1.24503 13.5523C1.26552 13.9234 1.43239 14.2712 1.70903 14.5193C1.83303 14.6543 1.98103 14.7663 2.14603 14.8473C2.31603 14.9223 2.49903 14.9653 2.68403 14.9743C3.00003 14.9683 3.30303 14.8483 3.53803 14.6373C5.08603 13.1803 8.05203 10.1873 9.73703 8.43334C10.194 8.62734 10.685 8.72734 11.181 8.72634C11.6803 8.72594 12.1744 8.62548 12.6342 8.43088C13.094 8.23628 13.5102 7.95149 13.858 7.59334C14.5726 6.8646 14.9717 5.88394 14.969 4.86334C14.9806 4.39631 14.9143 3.93062 14.773 3.48534V3.48534ZM2.93303 13.9283C2.89454 13.9625 2.84814 13.9866 2.79803 13.9983C2.74873 14.0069 2.69833 14.0069 2.64903 13.9983C2.59734 13.9905 2.5481 13.971 2.50503 13.9413C2.4588 13.9143 2.41972 13.8766 2.39103 13.8313C2.25103 13.6883 2.12003 13.4163 2.25103 13.2633C3.62103 11.8063 6.44203 8.95834 8.20603 7.21734C8.30603 7.34934 8.41603 7.47534 8.53403 7.59334C8.65203 7.71634 8.77903 7.83034 8.91403 7.93434C7.20803 9.68434 4.42603 12.4983 2.93403 13.9283H2.93303ZM14.051 4.86334C14.053 5.62834 13.755 6.36334 13.219 6.91134C12.6842 7.43603 11.9648 7.72996 11.2155 7.72996C10.4663 7.72996 9.7469 7.43603 9.21203 6.91134C8.82001 6.50223 8.55222 5.99023 8.43981 5.43488C8.32739 4.87954 8.37498 4.30369 8.57703 3.77434C8.71152 3.41407 8.92013 3.08604 9.18937 2.81147C9.4586 2.53689 9.78247 2.32188 10.14 2.18034C10.4795 2.03824 10.844 1.96548 11.212 1.96634H11.466L9.64903 3.83934V4.53534L11.544 6.42134H12.204L14.051 4.60534V4.86334V4.86334ZM3.24003 6.68834H4.77103L5.47603 7.40534L6.15403 6.73134L5.48903 6.05334V6.01034L5.54603 4.36134L5.32603 3.92434L2.46603 2.04234L1.87503 2.10834L1.04403 2.95734L0.978027 3.55634L2.81603 6.47434L3.24003 6.68934V6.68834ZM2.29503 3.05634L4.60903 4.58034L4.57003 5.70334H3.49403L2.00203 3.34134L2.29503 3.05634V3.05634ZM9.40003 10.0163L10.074 9.34334L13.18 12.5283C13.4416 12.8033 13.5876 13.1683 13.5876 13.5478C13.5876 13.9274 13.4416 14.2924 13.18 14.5673C12.9833 14.7693 12.7303 14.9074 12.4541 14.9635C12.1778 15.0197 11.891 14.9914 11.631 14.8823C11.4651 14.8087 11.3163 14.7015 11.194 14.5673L8.05203 11.3643L8.73103 10.6863L11.863 13.8803C11.9051 13.9268 11.9575 13.9627 12.016 13.9853C12.1311 14.0321 12.2599 14.0321 12.375 13.9853C12.4335 13.9627 12.4859 13.9268 12.528 13.8803C12.5718 13.837 12.6059 13.7848 12.628 13.7273C12.651 13.6687 12.6632 13.6063 12.664 13.5433C12.663 13.4804 12.6512 13.4182 12.629 13.3593C12.6069 13.3018 12.5728 13.2497 12.529 13.2063L9.40003 10.0163Z"
                        fill="#03C962"
                      />
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>Services</p>
                  </div>
                </div>
              </NavLink>
            </div> */}

            <div className={styles.nav_container}>
              <NavLink
                to="/reset-password"
                className={(navData) =>
                  navData.isActive ? `${styles.active}` : ""
                }
              >
                <div>
                  <div className={styles.svg}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 18H13V6L8 8V13L4 15V7L13 3L20 5V18L13 21L4 18Z"
                        stroke="#03C962"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div className={styles.title}>
                    <p>Reset Password</p>
                  </div>
                </div>
              </NavLink>
            </div>

            {/* <div>
              <div className={styles.svg}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 18H13V6L8 8V13L4 15V7L13 3L20 5V18L13 21L4 18Z"
                    stroke="#03C962"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.title}>
                <p>About us</p>
              </div>
            </div> */}

            {/* <div>
              <div className={styles.svg}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 18H13V6L8 8V13L4 15V7L13 3L20 5V18L13 21L4 18Z"
                    stroke="#03C962"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.title}>
                <p>About us</p>
              </div>
            </div> */}

            <div
              className={`${styles.nav_container} ${styles.logout}`}
              onClick={(e) => {
                e.stopPropagation();
                setModal(true);
              }}
            >
              <NavLink>
                <div className={styles.svg}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 22.5H13.5C13.8977 22.4996 14.279 22.3414 14.5602 22.0602C14.8414 21.779 14.9996 21.3977 15 21V18.75H13.5V21H4.5V3H13.5V5.25H15V3C14.9996 2.6023 14.8414 2.221 14.5602 1.93978C14.279 1.65856 13.8977 1.5004 13.5 1.5H4.5C4.1023 1.5004 3.721 1.65856 3.43978 1.93978C3.15856 2.221 3.0004 2.6023 3 3V21C3.0004 21.3977 3.15856 21.779 3.43978 22.0602C3.721 22.3414 4.1023 22.4996 4.5 22.5Z"
                      fill="#FD4D1E"
                    />
                    <path
                      d="M15.4395 15.4395L18.129 12.75H7.5V11.25H18.129L15.4395 8.5605L16.5 7.5L21 12L16.5 16.5L15.4395 15.4395Z"
                      fill="#FD4D1E"
                    />
                  </svg>
                </div>
                <div className={styles.title}>
                  <p>Logout</p>
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
